"use client";

import styles from "./SignUpPageHeader.module.scss";

import { WEBSITE_URL } from "@/constants";
import { buildLoginHrefWithNext } from "@/helpers";

import { useTranslations, useLocale } from "@/i18n";
import { useSearchParams } from "react-router-dom";
import { Flex } from "@vetty/ui";

/**
 * SignUpPageHeader Component
 *
 * Header for the sign up page. Preserves safe `next` when linking to login.
 */
export const SignUpPageHeader = () => {
  const t = useTranslations("signUp.header");
  const locale = useLocale();
  const [searchParams] = useSearchParams();
  const nextParam = searchParams.get("next");

  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      <a
        href={`${WEBSITE_URL}/${locale}`}
        className={styles["comp__logo-link"]}
      >
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        <a
          href={`${WEBSITE_URL}/${locale}/university#contact-sales`}
          className={styles["comp__menu__item"]}
        >
          {t("contactSales")}
        </a>

        <a
          href={buildLoginHrefWithNext(locale, nextParam)}
          className={styles["comp__menu__item"]}
        >
          {t("logIn")}
        </a>
      </Flex>
    </Flex>
  );
};
